/**
 * Строка истории держателя договора → основание смены словами (ключи каталога).
 *
 * Пусто у строки базового приказа: держатель стоит в нём с начала года. Смена
 * держателя по реорганизации называет форму и дату допсоглашения — это и есть
 * «почему»; пункт правки называет, где это написано.
 */
import type { QuotaContractHolder } from '../api'
import { msg } from '../i18n/types'
import type { Msg } from '../i18n/types'

export function holderBasis(h: QuotaContractHolder): Msg[] {
  if (h.reason === 'base' || !h.order) return []
  const out: Msg[] = []
  if (h.event_kind) out.push(msg(`quotas.hist.kind.${h.event_kind}`))
  else out.push(msg(`quotas.hist.reason.${h.reason}`))
  if (h.agreement_date) out.push(msg('quotas.hist.agreement', { date: h.agreement_date }))
  out.push(msg(h.order.item ? 'quotas.hist.orderItem' : 'quotas.hist.order',
               { no: h.order.no, date: h.order.date, item: h.order.item ?? '' }))
  return out
}

/** Строки нет в таблице (выпала при переписи) — держателя у отрезка нет. */
export function isGap(h: QuotaContractHolder): boolean {
  return h.inn === null && h.reason === 'rewritten_out'
}
